import { Link } from "react-router-dom";
import img1 from "../../assets/Images/Event Booking/Create-Event-Booking.png"
import DocNavigation from "../../components/DocNavigation";

export default function StaffEfficiency() {
    return (
        <section className="space-y-16">

            <section className="bg-white rounded-xl border border-slate-200 p-10">
                <h1 className="text-2xl font-bold text-slate-900 mb-4">
                    Improved Staff Efficiency
                </h1>

                <p className="text-md text-slate-600 max-w-4xl">
                    EventFlow is designed to simplify daily operations, reduce repetitive
                    tasks, and enable staff to focus on customer service rather than manual
                    administration.
                </p>

                <section className="border-l border-[#C9A24E] pl-4 mt-6">
                    <h2 className="text-lg font-semibold mb-3">Overview</h2>
                    <p className="text-slate-600 text-sm">
                        Automation, structured workflows, and guided forms help staff
                        complete tasks faster and with fewer errors.
                    </p>
                </section>
            </section>

            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-4">Operational Bottlenecks Without a System</h3>
                <ul className="list-disc pl-5 text-slate-600 space-y-2">
                    <li>Repeated data entry</li>
                    <li>Manual calculations</li>
                    <li>Unclear task ownership</li>
                    <li>High training time for new staff</li>
                </ul>
            </section>

            <section className="p-4">
                <div>
                    <h3 className="font-semibold mb-3">
                        How EventFlow Boosts Productivity
                    </h3>
                    <ul className="list-disc pl-5 text-slate-600 space-y-1">
                        <li>Auto-calculated totals & balances</li>
                        <li>Guided booking & payment workflows</li>
                        <li>Reduced paperwork</li>
                        <li>Faster onboarding for new employees</li>
                    </ul>
                </div>

                <div className="p-6 flex justify-center items-center">
                    <img src={img1} alt="" className="w-1/2 h-auto shadow-lg"/>
                </div>
            </section>

            <section className="bg-slate-100 rounded-xl p-8">
                <p className="text-slate-600 max-w-4xl">
                    Improved staff efficiency directly translates into better customer
                    experience, faster operations, and increased profitability.
                </p>
            </section>

            {/* <section className="border-t pt-8 mt-12">
                <p className="text-slate-600">
                    Next, Look into our{" "}
                    <Link to="/docs/plans" className="font-medium text-[#C9A24E]">
                        Pricing
                    </Link>.
                </p>
            </section> */}
       <DocNavigation
                previous={{
                    title: "Organized Record Keeping",
                    link: "/docs/records"
                }}
                next={{
                    title: "Customization",
                    link: "/docs/customization"
                }}
            />
        </section>
    );
}
